/**
 * Randomize array in-place using Durstenfeld shuffle algorithm
 * Note that the shuffle is done in-place!
 * Copied from: https://stackoverflow.com/a/12646864
 */
export function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}
